// A opção de frete escolhida é reconhecida na lista por transportadora, serviço, tabela e valor.
// Só transportadora e valor confundiam PAC e SEDEX dos Correios, que o DataFrete devolve com o mesmo
// preço: as duas ficavam marcadas. Pedido salvo não guarda a tabela: vazio dos dois lados também bate.
const texto = (v) => String(v ?? '');

export function mesmaOpcaoDeFrete(a, b) {
  if (!a || !b) return false;
  return a.transportadora === b.transportadora
    && texto(a.servico) === texto(b.servico)
    && texto(a.cod_tabela) === texto(b.cod_tabela)
    && a.valor === b.valor;
}
